module.exports = __webpack_public_path__ + "static/media/hub-logo.dfdaed58.png";